const initContact = () => {
	const section = document.querySelector('.contact-page[data-contact-api]');
	if (!section) return;
	const api = section.dataset.contactApi;
	const requestJson = async (url, options) => {
		try {
			const response = await fetch(url, options);
			return { response, result: await response.json() };
		} catch {
			throw new Error('Nie można połączyć się z usługą. Spróbuj ponownie.');
		}
	};
	const post = async (route, data) => {
		// Public requests deliberately omit WP login cookies: tokens stay anonymous and cache-independent.
		const { response: tokenResponse, result: token } = await requestJson(`${api}contact-token`, { credentials: 'omit', cache: 'no-store' });
		if (!tokenResponse.ok) throw new Error('Nie można połączyć się z usługą. Spróbuj ponownie.');
		const { response, result } = await requestJson(`${api}${route}`, {
			method: 'POST', credentials: 'omit', cache: 'no-store',
			headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': token.nonce }, body: JSON.stringify(data),
		});
		if (!response.ok) {
			const error = new Error(result.message || 'Nie udało się wykonać operacji. Spróbuj ponownie.');
			error.fields = result.data?.fields;
			throw error;
		}
		return result;
	};
	section.querySelectorAll('[data-contact-reveal]').forEach(button => {
		button.disabled = false;
		button.addEventListener('click', async () => {
			const status = button.parentElement.querySelector('[role="status"]');
			button.disabled = true;
			button.setAttribute('aria-busy', 'true');
			status.textContent = '';
			try {
				const result = await post('contact-detail', { kind: button.dataset.contactReveal });
				const link = document.createElement('a');
				link.href = result.href;
				link.textContent = result.value;
				link.className = 'contact-page__revealed';
				button.replaceWith(link);
				link.focus();
			} catch (error) {
				status.textContent = error.message;
				button.disabled = false;
				button.removeAttribute('aria-busy');
			}
		});
	});
	const form = section.querySelector('.contact-form');
	const submit = form.querySelector('[type="submit"]');
	const status = form.querySelector('[role="status"]');
	submit.disabled = false;
	form.addEventListener('submit', async event => {
		event.preventDefault();
		if (!form.reportValidity()) return;
		form.querySelectorAll('[aria-invalid]').forEach(field => field.removeAttribute('aria-invalid'));
		form.querySelectorAll('.contact-form__error').forEach(error => { error.textContent = ''; });
		submit.disabled = true;
		form.setAttribute('aria-busy', 'true');
		status.textContent = 'Sprawdzanie wiadomości…';
		try {
			const result = await post('contact-submit', Object.fromEntries(new FormData(form)));
			status.textContent = result.message;
			form.reset();
		} catch (error) {
			status.textContent = error.message;
			Object.entries(error.fields || {}).forEach(([name, message]) => {
				const field = form.elements.namedItem(name);
				if (!field || !['name', 'company', 'email', 'message'].includes(name)) return;
				field.setAttribute('aria-invalid', 'true');
				form.querySelector(`#contact-${name}-error`).textContent = message;
			});
			form.querySelector('[aria-invalid]')?.focus();
		} finally {
			submit.disabled = false;
			form.removeAttribute('aria-busy');
		}
	});
};
export default initContact;
